import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";
import { tokenRequest } from "../authConfig";

//REF: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
const msalInstance = new PublicClientApplication(msalConfig);
// Ref: https://docs.microsoft.com/en-us/azure/active-directory/develop/scenario-spa-acquire-token?tabs=javascript2

export class AuthService {
  async getAccessToken() {
    const account = msalInstance.getAllAccounts()[0];
    const accessTokenRequest = {
      ...tokenRequest,
      account: account
    }

    let accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest)
      .catch(function (error) {
        console.log(error);
      });

    if (accessTokenResponse !== undefined) {
       return accessTokenResponse.accessToken;
    }
    return null;
    //if (this.context === undefined || this.context.inProgress === "login") {
    //  return null;
    //}

    //if (this.context.accounts.length == 0) {
    //  return null;
    //}

    //const request = {
    //  ...loginRequest,
    //  account: this.context.accounts[0]
    //};

    //var response = await this.context.instance.acquireTokenSilent(request).catch((e) => {
    //  console.log(`Error obtaining accessToken ${e.message}`);
    //});

    //if (response !== undefined && response !== null) {
    //  return null;
    //}

    //return response.accessToken;
  }

  static get instance() { return authService }
}

const authService = new AuthService();

export default authService;
